import {
  CampaignModel,
  IntegrationFileModel,
  ResponseCampaignModel,
} from '@/app/shared/models';
import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';

export class CampaignService extends HttpService {
  public async GetTemplateFiles(): Promise<IntegrationFileModel[]> {
    return await this.get<IntegrationFileModel[]>(
      `${env.billingUri}/settings/integrations/file?filter=Type=Campaign`
    ).then(({ data }) => data);
  }

  public async GetSettingCampaingByTenant(
    tenantId: string
  ): Promise<CampaignModel[]> {
    return await this.get<CampaignModel[]>(
      `${env.billingUri}/settings/campaign?filter=TenantId=${tenantId}`
    ).then(({ data }) => data);
  }

  public async GetCampaignByContractId(
    contractId: string,
    limit: 100
  ): Promise<ResponseCampaignModel[]> {
    return await this.get<ResponseCampaignModel[]>(
      `${env.billingUri}/Contracts/${contractId}/campaigns`,
      {
        params: { limit },
      }
    ).then(({ data }) => data);
  }

  public async GetFollowUpByContractId(
    contractId: string,
    limit: 100
  ): Promise<ResponseCampaignModel[]> {
    return await this.get<ResponseCampaignModel[]>(
      `${env.billingUri}/Contracts/${contractId}/installments/notifies`,
      {
        params: { limit },
      }
    ).then(({ data }) =>
      data.map((item) => ({
        ...item,
        notifyId: item.Id,
      }))
    );
  }
}
